export const getInitialState = (): any => ({
  modelSummaryArraysData: {},
  modelSummaryArraysStatus: 0
});
